import React from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import SendToAppModal from "web/react/components/send-to-app-modal/send-to-app-modal";
import { closeOOSModal } from "web/redux/ducks/send-to-app-modal";
import { ReduxStoreState } from "web/redux/store";
import { gettext, gettextNoop } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import { RawBranchLink } from "web/script/utils/branch-io";
import genericProductImage from "./images/generic-product-image.png";

interface OOSSendToAppModalProps {
    productImageUrl: string;
    leadUrl: string;
    productId: string;
    productUrl: string;
}

function extractState(state: ReduxStoreState): boolean {
    return state.sendToAppModalReducer.OOSModalIsOpen;
}

export default function OOSSendToAppModal({
    productImageUrl,
    productUrl,
}: OOSSendToAppModalProps): JSX.Element {
    const dispatch = useDispatch();
    const OOSModalIsOpen = useReduxSelector(extractState);
    const titleVariant = environment.getFeature("mg_oos_app_or_retailer_title");

    function onClose(): void {
        dispatch(closeOOSModal());
    }

    const titleTranslationKeys = {
        title_2: gettextNoop("feed.show_more.app_overlay_block.title_2"),
        title_3: gettextNoop("feed.show_more.app_overlay_block.title_3"),
        title_4: gettextNoop("feed.show_more.app_overlay_block.title_4"),
    };

    let appDeepLinkProductUrl;
    try {
        appDeepLinkProductUrl = new URL(productUrl);
    } catch (err) {
        console.error(`${productUrl} is not a valid URL`);
    }

    if (!productImageUrl) {
        productImageUrl = genericProductImage;
    }

    const saveForLaterRedesignFeature = environment.getFeature(
        "mg_oos_save_for_later_redesign_ios"
    );
    const modalTitle = saveForLaterRedesignFeature
        ? gettext("oos_product.bis_app_overlay_block.title_1")
        : gettext(titleTranslationKeys[titleVariant.toString()]);

    const branchLink = saveForLaterRedesignFeature
        ? RawBranchLink.OOSNotifyMe
        : RawBranchLink.OOSGoToRetailer;

    return (
        <SendToAppModal
            isOpen={OOSModalIsOpen}
            onClose={onClose}
            title={modalTitle}
            url={branchLink}
            analyticsEventLabel={"oos_go_to_retailer_block"}
            productImageURL={productImageUrl}
            appDeepLinkURL={appDeepLinkProductUrl}
        />
    );
}
